import { useEffect } from 'react';

import { ImageProps } from '../Image.types';

import { loadImages, canUseDOM } from '../../../utils';
import { constants, URL_CONSTANTS } from '../../../constants';

export const useImage = (props: ImageProps) => {
  const { title, url, size, appliedClass, renditions, dynamic, isLazy, fetchpriority, imageUrls } = props;
  const largeDesktop = size?.largeDesktop;
  const desktop = size?.desktop;
  const tablet = size?.tablet;
  const mobile = size?.mobile;
  const sizes = { xlarge: '', large: '', medium: '', small: '' };
  const { BASE_IMG_URL } = URL_CONSTANTS;
  const { DOWNSIZE_PARAM, IMG_ALT_TEXT } = constants;
  if (size !== undefined) {
    sizes.xlarge = largeDesktop ? `${DOWNSIZE_PARAM}${largeDesktop}` : '';
    sizes.large = `${DOWNSIZE_PARAM}${desktop}`;
    sizes.medium = `${DOWNSIZE_PARAM}${tablet}`;
    sizes.small = `${DOWNSIZE_PARAM}${mobile}`;
  }
  const defaultImage = renditions?.[0]?.renditionPath;
  useEffect(() => {
    if (canUseDOM) {
      if (document.readyState !== 'loading') {
        loadImages();
      } else {
        document.addEventListener('DOMContentLoaded', loadImages);
      }
    }
  }, [url]);
  return {
    title,
    url,
    appliedClass,
    dynamic,
    renditions,
    IMG_ALT_TEXT,
    BASE_IMG_URL,
    defaultImage,
    sizes,
    isLazy,
    fetchpriority,
    imageUrls,
  };
};
